import { SiriusBaseComponent } from 'sirius-framework';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router'
import { ViewChild,OnDestroy, ElementRef, Component, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Images } from '../../models/images.model'; 
import { MenuItem,MenuItemType } from '../../models/menuItem';
import { Subscription } from 'rxjs'; 
import { CommonService } from '../../service/shared.service';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'] 
})

export class HeaderComponent extends SiriusBaseComponent<any> implements OnDestroy {   
    @ViewChild('navbarToggler') navbarToggler: ElementRef;
    @ViewChild('navbarCollapse') navbarCollapse: ElementRef;  
    _images = Images;
    subscriptionLoggedId: Subscription;
    subscriptionLoggedUser: Subscription;
    subscriptionLoginPageControl: Subscription;
    notLoginPage: boolean = true;
    isLoggedIn: boolean = false;
    loggedUserName: string;
    isHeightLong: boolean = true;
    isCollapsed: boolean = true;
    loginButtonText: string = 'Giriş';
    signOutButtonText: string = 'Çıkış'; 
    menuItems: MenuItem[] = [];
    constructor(private router: Router, private renderer: Renderer2, private domSanitizer: DomSanitizer, private commonService: CommonService) {
        super();     
        this.commonService.notAtLoginPage.next(true);
    }
    OnInit() {	    
        this.router.events.subscribe(e => {
          if (e instanceof NavigationEnd) {
                // route değişirse menüyü kapat ve scroll'u aç
                 this.renderer.removeClass(document.body, 'block-scroll');
                 this.renderer.removeClass(this.navbarCollapse.nativeElement, "show");
                 
                if (e.urlAfterRedirects.includes('/landing')) {
                    this.isHeightLong = true;
                }
                else {
                    this.isHeightLong = false;
                }
            }
        });
        this.renderer.listen('window', 'click', (e: Event) => {
          if (this.navbarCollapse.nativeElement.classList.contains('show') &&
            e.target !== this.navbarCollapse.nativeElement &&
            e.target !== this.navbarToggler.nativeElement) {
            this.isCollapsed = true;
            this.renderer.removeClass(this.navbarCollapse.nativeElement, "show");
          } else if (!this.isCollapsed) { 
            this.renderer.addClass(this.navbarCollapse.nativeElement, "show");
          }
        });
        let menuItem1 = new MenuItem();
        menuItem1.text = "Yardım";
        menuItem1.itemCssClass = "nav-item";
        menuItem1.linkCssClass = "nav-link";
        menuItem1.routeLink = "/faq";
        menuItem1.type = MenuItemType.Text;
        this.menuItems.push(menuItem1);
        let menuItem2 = new MenuItem();
        menuItem2.text = "Ana Sayfa";
        menuItem2.itemCssClass = "nav-item";
        menuItem2.linkCssClass = "nav-link";
        menuItem2.routeLink = "/inner-menu";
        menuItem2.type = MenuItemType.Text;
        

        this.subscriptionLoggedId = this.commonService.isLoggedin.subscribe(state => {
            this.isLoggedIn = (state == true);
            if (this.isLoggedIn) {
                this.menuItems.push(menuItem2);
            }
            else {
                this.menuItems = [];
                this.menuItems.push(menuItem1);
            }
        });
        this.subscriptionLoggedUser = this.commonService.loggedUserName.subscribe(state => {
            this.loggedUserName =  state;
        });
        this.subscriptionLoginPageControl = this.commonService.notAtLoginPage.subscribe(state => {
            if (state == false)
                this.notLoginPage = false;
            else
                this.notLoginPage = true;
        });
    }
    ngOnDestroy() {
        this.subscriptionLoggedId.unsubscribe();
        this.subscriptionLoggedUser.unsubscribe();
        this.subscriptionLoginPageControl.unsubscribe();
        this.renderer.removeClass(document.body, 'block-scroll');
    }
    getHeaderImage() {
        return this.domSanitizer.bypassSecurityTrustStyle(`url(${Images.Other.Logo})`);                      
    }
    getHeaderImageShort() {
        return this.domSanitizer.bypassSecurityTrustStyle(`url(${Images.Other.LogoScroll})`); 
    }
    goLogin() {
      this.startTransaction('LoginFormTransaction');
    }
    onMenuClick() {
        this.isCollapsed = !this.isCollapsed;
        this.arrangeBody();
    }
    arrangeBody() {
        if (!this.isCollapsed) {
            this.renderer.addClass(document.body, 'block-scroll');
        } else {
            this.renderer.removeClass(document.body, 'block-scroll');
        }
  }

  closeMenuOnNavigate() {
    if (!this.isCollapsed) {
      this.isCollapsed = true;
      this.arrangeBody();
      this.renderer.removeClass(this.navbarCollapse.nativeElement, "show");
    }
  }

    signOut() { 
        this.commonService.logOut(false);
    }
}
